import React, { Fragment, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Row } from 'reactstrap';
import { useStores } from '../../hooks/use-stores';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import IntegrationElement from './IntegrationElement';
import { Heading2, Heading4, TextDefault } from '@awarego-ui/components';

function IntegrationsSettings({ companyId }) {
    const { companyStore, brandingStore } = useStores();
    const {
        loadingIntegrations,
        connectedIntegrations,
        availableIntegrations,
    } = companyStore;

    useEffect(() => {
        loadData();
    }, [companyId]);

    const loadData = async () => {
        await companyStore.loadIntegrations(companyId);
    };

    return loadingIntegrations ? (
        <ThemedSpinner />
    ) : (
        <div className="top-guide">
            <div className="block new-settings-block">
                <div className="row">
                    <div className="col-md-8 ">
                        <Heading2 displayBlock>Integrations</Heading2>
                        <TextDefault lighter>
                            Manage integrations with external services and
                            applications
                        </TextDefault>
                    </div>
                </div>
                <br />
                {connectedIntegrations.length > 0 && (
                    <Fragment>
                        <Heading4>Connected</Heading4>
                        <Row>
                            {connectedIntegrations.map((integration) => (
                                <IntegrationElement
                                    integration={integration}
                                    key={integration.id}
                                />
                            ))}
                        </Row>
                        <br />
                        <hr />
                        <br />
                    </Fragment>
                )}
                {availableIntegrations.length > 0 && (
                    <Fragment>
                        <Heading4>
                            Available {brandingStore.account_name} Integrations
                        </Heading4>
                        <Row>
                            {availableIntegrations.map((integration) => (
                                <IntegrationElement
                                    integration={integration}
                                    key={integration.id}
                                    supportEmail={brandingStore.supportEmail}
                                />
                            ))}
                        </Row>
                    </Fragment>
                )}
            </div>
        </div>
    );
}

export default observer(IntegrationsSettings);
